function toBase64(buffer) {
  let binary = ''
  for (const byte of new Uint8Array(buffer)) {
    binary += String.fromCodePoint(byte)
  }
  return btoa(binary)
}

function base64ToBytes(value) {
  return Uint8Array.from(atob(value), c => c.codePointAt(0))
}

function getDerFromPublicKey(publicKey) {
  if (typeof publicKey !== 'string') {
    return null
  }

  const keyContent = publicKey.includes('-----BEGIN')
    ? publicKey.replace(
        /-----BEGIN PUBLIC KEY-----|-----END PUBLIC KEY-----|\s/g,
        ''
      )
    : publicKey.replace(/\s/g, '')

  return base64ToBytes(keyContent)
}

export async function importPublicKey(publicKey) {
  if (typeof publicKey === 'object' && publicKey !== null) {
    return crypto.subtle.importKey(
      'jwk',
      publicKey,
      { name: 'RSA-OAEP', hash: 'SHA-256' },
      false,
      ['encrypt']
    )
  }

  const der = getDerFromPublicKey(publicKey)
  if (!der) {
    throw new Error('Invalid public key')
  }

  return crypto.subtle.importKey(
    'spki',
    der,
    { name: 'RSA-OAEP', hash: 'SHA-256' },
    false,
    ['encrypt']
  )
}

export async function encryptField(plaintext, publicKey) {
  const encoded = new TextEncoder().encode(plaintext)
  const ciphertext = await crypto.subtle.encrypt(
    { name: 'RSA-OAEP' },
    publicKey,
    encoded
  )
  return toBase64(ciphertext)
}
